import { getToken, setToken, removeToken } from "@/utils/storage";

export default {
	namespaced: true,

	state() {
		return {
			token: getToken() || ""
		};
	},

	mutations: {
		setUserToken(state, data) {
			state.token = data;
			setToken(data);
		},

		// 退出登录
		logout(state) {
			state.token = "";
			// 清楚本地token
			removeToken();
		}
	}
};
